var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index_role_and_prize"},[_c('wd-img',{staticClass:"png_role",attrs:{"src":_vm.roleBtn},on:{"click":_vm.toRole}}),_c('wd-img',{staticClass:"png_prize",attrs:{"src":_vm.prizeBtn},on:{"click":_vm.toPrize}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }